// extracted by mini-css-extract-plugin
export default {"headerText":"access-denied_headerText__D-DNb","infoText":"access-denied_infoText__zs1FC"};